<template>
  <div class="flex-column h100">
    <navbar title="出厂查询"></navbar>
    <div class="exitFactory flex1 flex-column">
      <div class="query">
        <div class="inblock">
          <span class="demonstration">出厂时间 :</span>
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
        <div class="inblock">
          <span class="demonstration">出厂门店 :</span>
          <el-select v-model="store" placeholder="请选择">
            <el-option
              v-for="item in options1"
              :key="item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="inblock">
          <span class="demonstration">驾驶员 :</span>
          <el-select v-model="driver" placeholder="请选择">
            <el-option
              v-for="item in options2"
              :key="item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="inblock">
          <span class="demonstration">出厂单号 :</span>
          <el-input v-model="oddNumbers" placeholder="请输入内容"></el-input>
        </div>
        <div class="but inblock">
          <el-button type="primary" @click="_query">查询</el-button>
          <el-button type="primary">重新打印</el-button>
        </div>
      </div>
      <div class="flex">
        <div class="table-left">
          <el-table
            border
            :data="factoryData"
            :height="tableHeight"
            style="width: 100%"
            @cell-dblclick="tableDbEdit"
            :row-class-name="tableRowClassName"
          >
            <el-table-column prop="create_time" label="出厂时间" width="150"></el-table-column>
            <el-table-column prop="exit_factory_no" label="出场单号" width="150"></el-table-column>
            <el-table-column prop="name" label="门店名称"></el-table-column>
            <el-table-column prop="factory_member_name" label="驾驶员"></el-table-column>
          </el-table>
        </div>
        <div class="table-right flex1">
          <el-table
            border
            :data="tableData"
            :height="tableHeight"
            style="width: 100%"
            :row-class-name="tableRowClassName"
          >
            <el-table-column prop="order_no" label="订单号"></el-table-column>
            <el-table-column prop="code_num" label="条形码"></el-table-column>
            <el-table-column prop="name" label="衣物名称"></el-table-column>
            <el-table-column prop="create_time" label="时间"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import header from '@/components/header'
export default {
  components: {
    navbar: header
  },
  data() {
    return {
      tableHeight: window.innerHeight - 100,
      time: [new Date(), new Date()],
      oddNumbers: '',
      store: '',
      driver: '',
      options1: [],
      options2: [],
      factoryData: [],
      tableData: []
    }
  },
  created() {
    this.time[0] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D')
    this.time[1] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D')
    Promise.all([this._query(), this.allShop()]).then(() => {
      if (this.factoryData.length > 0) this.getOutByNo(this.factoryData[0].exit_factory_no);
    })
  },
  methods: {
    tableDbEdit(row) {
      if (row['exit_factory_no']) this.getOutByNo(row.exit_factory_no);
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row';
      }
      return '';
    },
    // 按钮查询
    async _query() {
      let data = {
        startTime: this.time[0],
        endTime: this.time[1],
        shop_id: this.store,
        userID: this.driver,
        exit_factory_no: this.oddNumbers
      }
      let res = await this.$http.findOut(data)
      this.factoryData = res.data.data;
    },
    async getOutByNo(id) {
      if (id == null) return;
      let res = await this.$http.getOutByNo(id)
      this.tableData = res.data.data
    },
    async allShop() {
      let res = await this.$http.allShop()
      let res1 = await this.$http.allDriver()
      let data = {
        id: '',
        name: '请选择'
      }
      this.options2 = [data, ...res1.data.data]
      this.options1 = [data, ...res.data.data]
    }
  }
}
</script>
<style lang="less" scoped>
.exitFactory {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  margin-bottom: 30px;
  box-sizing: border-box;
  overflow: hidden;
  .query {
    padding: 20px 0px;
    box-sizing: border-box;
    .but {
      margin-left: 20px;
    }
  }
  .demonstration {
    margin-left: 5px;
    margin-right: 10px;
  }
  .table-left {
    width: 30%;
    margin-right: 30px;
    overflow-y: scroll;
  }
  .table-right {
    overflow-y: scroll;
  }
  .el-input {
    width: auto;
  }
}
</style>